import React from 'react'

const NoLiveSportTypes = () => <div></div>

export default NoLiveSportTypes